import ApiRequestForm from "../components/ApiRequestForm";
import domain from "../domain";

export default function AdminDashboardController() {
  return (
    <main style={{ padding: "1rem" }}>
      <h1>API Request</h1>
      <p>
        Send cookie-authenticated requests to{" "}
        <code>{domain || "(same origin)"}</code>.
      </p>
      <ApiRequestForm />
    </main>
  );
}
